export default "/images/vendor/flag-icon-css/flags/4x3/th.svg?b6ade2beba225ed5f2b5dc6487ffa54a";